import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

// Icons
import CheckIcon from "@material-ui/icons/Check";

// Backgrounds
import phones from "../../assets/backgrounds/getConnectedPage/book-demo-form-img.png";

// Components
import Section from "../../components/Section/Section";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import styles from "../../config/styles";
import FormContainer from "../../components/FormContainer/index";
import DemoVideoForm, { sources } from "../../components/DemoVideoForm/index";

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0",
      paddingRight: "0"
    }
  },
  bigIcon: {
    marginTop: theme.spacing(6)
  },
  formSection: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.paper
  },
  sectionBottom: {
    padding: theme.spacing(4)
  },
  form: {
    ...styles.mixins.form,
    backgroundColor: theme.palette.background.default,
    boxShadow: "10px 20px 60px #00000010",
    borderRadius: 30,
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      borderRadius: 0
    }
  },
  sectionTitle: {
    padding: "70px 0 20px"
  },
  formWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      width: "100%",
      padding: "0px 0 0"
    }
  },
  formData: {
    padding: "100px 0 40px",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0
    }
  },
  phones: {
    ...styles.mixins.icon,
    display: "flex",
    width: "50%",
    maxWidth: "600px",
    margin: `${theme.spacing(2)}px 0px`,
    marginRight: theme.spacing(4),
    backgroundImage: `url(${phones})`,
    backgroundPosition: "center center",
    transform: "translateY(10%) scale(1.4, 1.4)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: 430,
      width: "100%",
      height: 430,
      margin: "0 auto",
      transform: "none"
    }
  },
  highlight: {
    fontWeight: 800
  }
}));

const GetConnectedFormSection = () => {
  const classes = useStyles();
  const [isSent, setSent] = useState(false);

  const handleFormSubmit = () => {
    setSent(true);
  };

  return (
    <Section id="demo" className={classes.root}>
      <FormContainer className={classes.form}>
        <SectionTitle
          className={classes.sectionTitle}
          title="Book A Demo And Request Pricing"
          description="You’ll be glad you took the next step."
        />
        <div className={classes.formWrapper}>
          <div className={classes.phones} />
          <DemoVideoForm
            className={classes.formData}
            hideUserType
            source={sources.BOOK_DEMO}
            onSuccess={handleFormSubmit}
            isSent={isSent}
            buttonText={
              isSent ? (
                <>
                  Sent
                  <CheckIcon />
                </>
              ) : (
                "Book a Demo"
              )
            }
          />
        </div>
      </FormContainer>
    </Section>
  );
};

export default GetConnectedFormSection;
